type ExposeCallback = (message: Message) => void;

export function expose(callback: ExposeCallback, scope: Window = window): void {
  (scope as any).onExternalMessage = callback;
}
